export const aiProviders = [
  {
    id: 'openai',
    name: 'OpenAI',
    apiKeysPageUrl: 'https://platform.openai.com/api-keys',
    billingPageUrl: 'https://platform.openai.com/settings/organization/billing',
    prefix: 'sk-',
  },
  {
    id: 'anthropic',
    name: 'Anthropic',
    apiKeysPageUrl: 'https://console.anthropic.com/settings/keys',
    billingPageUrl: 'https://console.anthropic.com/settings/billing',
    prefix: 'sk-ant-',
  },
  {
    id: 'google',
    name: 'Google Gemini',
    apiKeysPageUrl: 'https://aistudio.google.com/apikey',
    billingPageUrl: 'https://console.cloud.google.com/billing',
    prefix: 'AIza',
  },
];

export const aiProviderName = (id?: string) =>
  aiProviders.find((provider) => provider.id === id)?.name ?? id ?? '';
